export default [
    'YES',
    'NO'
]
export const YesNoEnums = Object.freeze(({ 'YES': 1, 'NO': 0 }));